import { useTranslation } from 'react-i18next'
import { toast, ToastOptions } from 'react-toastify'
import { ApolloError } from '@apollo/client'
import { colors } from '../../const/colors'

/**
 * The single notification mechanism for the app. Imperative — call from
 * anywhere, no local state or rendered element needed; toasts appear in the
 * global <Toast /> container (bottom-center). Navy styling matches the
 * parking-pool design.
 */
const TOAST_STYLE = {
  background: colors.navy,
  color: '#fff',
  borderRadius: '16px',
  fontWeight: 600,
  fontSize: '14px',
}

const OPTS: ToastOptions = { style: TOAST_STYLE, autoClose: 3900, theme: 'dark' }

export const useSnackbar = () => {
  const { t } = useTranslation()

  /** show an arbitrary, already-translated message */
  const notify = (message: string) => toast.success(message, OPTS)

  /** standard "operation succeeded" toast */
  const notifySuccess = () => toast.success(t('generic:success_message'), OPTS)

  /** show an error — accepts an ApolloError/Error or a raw string */
  const notifyError = (error: ApolloError | Error | string) =>
    toast.error(typeof error === 'string' ? error : error.message, OPTS)

  return { notify, notifySuccess, notifyError }
}
